import { combineReducers } from "redux";
import { types } from "../actions";
import finance from "./finance";

const qid = (state = "", { type, payload }) => {
  switch (type) {
    case types.SET_QUOTE_ID:
      return payload;
    case types.RESET:
      return "";
    default:
      return state;
  }
};

const name = (state = "", { type, payload }) => {
  switch (type) {
    case types.SET_QUOTE_NAME:
      return payload;
    case types.RESET:
      return "";
    default:
      return state;
  }
};

const priceFlag = (state = "CPQ_N/A", { type, payload }) => {
  switch (type) {
    case types.SET_QUOTE_PRICE_FLAG:
      return typeof payload === 'undefined' ? 'CPQ_N/A' : payload;
    case types.RESET:
      return "CPQ_N/A";
    default:
      return state;
  }
};

const validPriceFlagList = (state = [], { type, payload }) => {
  switch (type) {
    case types.SET_VALID_QUOTE_PRICE_FLAG_LIST:
      return payload;
    case types.RESET:
      return [];
    default:
      return state;
  }
};

const isPrimary = (state = true, { type, payload }) => {
  switch (type) {
    case types.SET_QUOTE_IS_PRIMARY:
      return Boolean(payload);
    case types.RESET:
      return true;
    default:
      return state;
  }
};

const customerGroupCode = (state = "", { type, payload }) => {
  switch (type) {
    case types.SET_QUOTE_CUSTOMER_GROUP_CODE:
      return payload;
    case types.RESET:
      return "";
    default:
      return state;
  }
};

const customerGroupId = (state = 0, { type, payload }) => {
  switch (type) {
    case types.SET_QUOTE_CUSTOMER_GROUP_ID:
      return Number.parseInt(payload, 10) || 0;
    case types.RESET:
      return 0;
    default:
      return state;
  }
};

const opportunityType = (state = "", { type, payload }) => {
  switch (type) {
    case types.SET_QUOTE_OPPORTUNITY_TYPE:
      return payload;
    case types.RESET:
      return "";
    default:
      return state;
  }
};

const tenderCode = (state = "", { type, payload }) => {
  switch (type) {
    case types.SET_QUOTE_TENDER_CODE:
      return payload;
    case types.RESET:
      return "";
    default:
      return state;
  }
};

const isMsa = (state = false, { type, payload }) => {
  switch (type) {
    case types.SET_QUOTE_IS_MSA:
      return Boolean(payload);
    case types.RESET:
      return false;
    default:
      return state;
  }
};

const sfdcCustomerNumber = (state = "", { type, payload }) => {
  switch (type) {
    case types.SET_QUOTE_SFDC_CUSTOMER_NUMBER:
      return payload;
    case types.RESET:
      return "";
    default:
      return state;
  }
};

const targetSoftwareTotal = (state = 0, { type, payload }) => {
  switch (type) {
    case types.SET_QUOTE_TARGET_SOFTWARE_TOTAL:
      return Number(Number(payload).toFixed(2));
    case types.RESET:
      return 0;
    default:
      return state;
  }
};

const targetHardwareTotal = (state = 0, { type, payload }) => {
  switch (type) {
    case types.SET_QUOTE_TARGET_HARDWARE_TOTAL:
      return Number(Number(payload).toFixed(2));
    case types.RESET:
      return 0;
    default:
      return state;
  }
};

const targetSaasTotal = (state = 0, { type, payload }) => {
  switch (type) {
    case types.SET_QUOTE_TARGET_SAAS_TOTAL:
      return Number(Number(payload).toFixed(2));
    case types.RESET:
      return 0;
    default:
      return state;
  }
};

const softwareDeliveryAddressId = (state = "", { type, payload }) => {
  switch (type) {
    case types.SET_QUOTE_SOFTWARE_DELIVERY_ADDRESS_ID:
      return payload;
    case types.RESET:
      return "";
    default:
      return state;
  }
};

const softwareInstallationAddressId = (state = "", { type, payload }) => {
  switch (type) {
    case types.SET_QUOTE_SOFTWARE_INSTALLATION_ADDRESS_ID:
      return payload;
    case types.RESET:
      return "";
    default:
      return state;
  }
};

const saasDeliveryAddressId = (state = "", { type, payload }) => {
  switch (type) {
    case types.SET_QUOTE_SAAS_DELIVERY_ADDRESS_ID:
      return payload;
    case types.RESET:
      return "";
    default:
      return state;
  }
};

const saasInstallationAddressId = (state = "", { type, payload }) => {
  switch (type) {
    case types.SET_QUOTE_SAAS_INSTALLATION_ADDRESS_ID:
      return payload;
    case types.RESET:
      return "";
    default:
      return state;
  }
};

const customerBillingAddressId = (state = "", { type, payload }) => {
  switch (type) {
    case types.SET_QUOTE_CUSTOMER_BILLING_ADDRESS_ID:
      return payload;
    case types.RESET:
      return "";
    default:
      return state;
  }
};

const items = (state = [], { type, payload }) => {
  switch (type) {
    case types.ADD_QUOTE_ITEM:
      return [...state.filter(({ key }) => key !== payload.key), payload];
    case types.DELETE_QUOTE_ITEM:
      return state.filter(({ key }) => key !== payload.key);
    case types.SET_QUOTE_ITEM:
      return state.map(item => (item.key === payload.key ? payload : item));
    case types.SET_QUOTE_FINANCE_TYPE:
      return state.map(item => {
        return {
          ...item,
          options: item.options && item.options.map(option => {
            return {
              ...option,
              selections: option.selections.map(selection => {
                return {
                ...selection,
                financeType: selection.isSaas ? selection.financeType : payload
                }
              })
            }
          })
        }
      })
    case types.RESET:
      return [];
    default:
      return state;
  }
};

const itemValidationMap = (state = [], { type, payload }) => {
  switch (type) {
    case types.SET_QUOTE_ITEM_VALIDATION_MAP:
      return payload;
    case types.RESET:
      return [];
    default:
      return state;
  }
};

const tonerRecycleBox = (state = "1", { type, payload }) => {
  switch (type) {
    case types.SET_QUOTE_TONER_RECYCLE_BOX:
      return payload;
    case types.RESET:
      return "1";
    default:
      return state;
  }
};

const serviceTerm = (state = 12, { type, payload }) => {
  switch (type) {
    case types.SET_QUOTE_SERVICE_TERM:
      return Number(payload) || 0
    case types.RESET:
      return 12;
    default:
      return state;
  }
};

const backendValidationMessages = (state = [], { type, payload }) => {
  switch (type) {
    case types.SET_QUOTE_BACKEND_VALIDATION_MESSAGES:
      return payload
    case types.RESET:
      return [];
    default:
      return state;
  }
};
const backendValidationInProgress = (state = false, { type, payload }) => {
  switch (type) {
    case types.SET_QUOTE_BACKEND_VALIDATION_IN_PROGRESS:
      return payload
    case types.RESET:
      return false;
    default:
      return state;
  }
};

const sameSoftwareInstallDeliveryAddress = (state = false, { type, payload }) => {
  switch (type) {
    case types.SET_QUOTE_SAME_SOFTWARE_INSTALL_DELIVERY_ADDRESS:
      return payload
    case types.RESET:
      return false;
    default:
      return state;
  }
};

const sameSaasInstallDeliveryAddress = (state = false, { type, payload }) => {
  switch (type) {
    case types.SET_QUOTE_SAME_SAAS_INSTALL_DELIVERY_ADDRESS:
      return payload
    case types.RESET:
      return false;
    default:
      return state;
  }
};



export default combineReducers({
  qid,
  name,

  customerGroupCode,
  customerGroupId,

  opportunityType,
  tenderCode,

  isMsa,
  sfdcCustomerNumber,

  isPrimary,
  priceFlag,
  validPriceFlagList,

  targetSoftwareTotal,
  targetHardwareTotal,
  targetSaasTotal,

  items,
  itemValidationMap,

  finance,

  softwareDeliveryAddressId,
  softwareInstallationAddressId,
  customerBillingAddressId,

  saasDeliveryAddressId,
  saasInstallationAddressId,

  tonerRecycleBox,
  serviceTerm,

  backendValidationMessages,
  backendValidationInProgress,

  sameSoftwareInstallDeliveryAddress,
  sameSaasInstallDeliveryAddress
});
